import React, { Fragment, useMemo, useState } from 'react';
import { Button, Col, Collapse, DatePicker, Row, Select, Table, Tooltip } from 'antd';
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaJournalWhills } from "react-icons/fa";

import '../css/collasible.css';
import ReportsToPDF from '../components/ReportsToPDF';
import { BlobProvider } from '@react-pdf/renderer';
import { useLoaderData, useParams } from 'react-router-dom';
import GHSymbol from '../components/GHSymbol';


const options = [
  {
    value: 'jack',
    label: 'Jack',
  },
  {
    value: 'lucy',
    label: 'Lucy',
  },
  {
    value: 'Yiminghe',
    label: 'yiminghe',
  },
];

const columns = [
  {
    title: '',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-black dark:text-white',
  },
  {
    title: 'Number',
    dataIndex: 'number',
    key: 'number',
    className: 'whitespace-nowrap font-medium text-black dark:text-white',
    width: '17%'
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    className: 'whitespace-nowrap font-medium text-black dark:text-white',
    width: '17%'
  },
  {
    title: 'Label',
    dataIndex: 'label',
    key: 'label',
    className: 'whitespace-nowrap font-medium text-black dark:text-white',
    width: '25%'
  },
  {
    title: 'Debit',
    dataIndex: 'debit',
    key: 'debit',
    className: 'whitespace-nowrap font-medium text-black dark:text-white',
    // width: '10%',
    align: 'right',
    render: (_, record) => <span>{ record.debit && new Intl.NumberFormat('en-Gh', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(record.debit) +' GHc'}</span>
  },
  {
    title: 'Credit',
    dataIndex: 'credit',
    key: 'credit',
    className: 'whitespace-nowrap font-medium text-black dark:text-white',
    // width: '10%',
    align: 'right',
    render: (_, record) => <span>{record.credit && new Intl.NumberFormat('en-Gh', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(record.credit) + ' GHc' }</span>
  },
  {
    title: 'Balance',
    dataIndex: 'total',
    key: 'total',
    className: 'whitespace-nowrap font-medium text-black dark:text-white',
    // width: '10%',
    align: 'right',
    render: (_, record) => <span> {record.total && new Intl.NumberFormat('en-Gh', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(record.total) + ' GHc' }</span>
  },
]


const GeneralLegder = () => {
  const [filter, setFilter] = useState({date: '', journal_code: ''})
  const reports = useLoaderData();
  const params = useParams();

  const onChangeDate = (date, dateString) => setFilter({ ...filter, date: dateString });
  const onChangeJournal = (v) => setFilter({ ...filter, journal_code: v });
  

  // const memoizedDocument = useMemo(() => <ReportsToPDF data={report} reportType={'Journal Report'} />, []);

  
  return (
    <div className='container mx-auto h-full' style={{maxWidth: '1200px'}}>
      <div className='bg-white mb-3 p-1'>
        <div>
          <h2 className='font-semibold text-xl text-[#04949b]'>{'General Ledger Report'}</h2>
        </div>
        <div className='flex justify-between p-2'>
          {/* <div>
            <Button className='bg-[#04949b] text-white border-0 hover:bg-[#04949b] font-semibold'>
              <BlobProvider document={memoizedDocument}>
                  {({ url, loading, error }) => {
                    if (loading) return 'Loading document...';
                    if (error) return 'Error loading document';
                    return (
                      <a href={url} target="_blank" rel="noopener noreferrer">
                        PDF
                      </a>
                    );
                  }}
                </BlobProvider>
            </Button>
          </div> */}
          <Row className='w-1/2'>
            <Col lg={10} className='flex items-center text-[#04949b] w-1/2'>
              <span className='w-1/2 font-normal flex items-center font-semibold'><FaRegCalendarAlt className='me-1'/>As of</span>
              <DatePicker suffixIcon={false} defaultValue={filter.date} onChange={onChangeDate} className='border-x-0 border-t-0 ps-0 text-[#04949b] font-semibold focus:shadow-none input-outline-none w-full border-0 font-normal'/>
            </Col>
            <Col lg={10} className='flex items-center text-[#04949b] w-1/2'>
              <span className='w-1/2 font-normal flex items-center font-semibold'><FaJournalWhills className='me-1'/>Journals:</span>
              <Select variant="borderless" value={filter.journal_code} onChange={onChangeJournal} suffixIcon={false} className='w-full font-semibold text-[#04949b]' options={options}/>
            </Col>
          </Row>
        </div>
      </div>
      <div className='bg-white p-3'>
        <div className='mb-2'>
          <Table 
            rowKey={'key'}
            columns={columns}
            rowClassName={'hover:cursor-pointer'}
            dataSource={reports}
            expandable={{
              expandRowByClick: true,
              // expandedRowClassName: 'font-semibold'
            }}
            pagination={false}
          />
        </div>
      </div>
    </div>
  )
};

export default GeneralLegder;